import { Action, createAction } from 'redux-actions';
import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { API_PATH } from '@/constants';
import { ICognitoReTryFlowSession } from '@/models/users';
import { mergeSaga } from '@/utils/redux-saga/merge-saga';
import { vipApi } from '@/utils/vip-api';
import { userReducer, UserSliceType } from '@/api/user/user.reducer';
import { getUserInfoAction } from '@/api/user/actions/get-user-info.action';
import { toggleVerifyIdentityDialogAction } from '@/api/user/actions/toggle-verify-identity-dialog.action';

const suffix = `/${userReducer.sliceName}/app`;

const COGNITO_RETRY_FLOW = `COGNITO_RETRY_FLOW${suffix}`;
export const createCognitoRetryAction = createAction(COGNITO_RETRY_FLOW);
const CLEAR_COGNITO_URL = `CLEAR_COGNITO_URL${suffix}`;
export const clearCognitoUrlAction = createAction(CLEAR_COGNITO_URL);

const COGNITO_RETRY_FLOW_ERROR = `COGNITO_RETRY_FLOW_ERROR${suffix}`;
const createCognitoRetryErrorAction = createAction<string>(COGNITO_RETRY_FLOW_ERROR);
const COGNITO_RETRY_FLOW_SUCCESS = `COGNITO_RETRY_FLOW_SUCCESS${suffix}`;
const createCognitoRetrySuccessAction = createAction<ICognitoReTryFlowSession>(COGNITO_RETRY_FLOW_SUCCESS);

function* createCognitoRetryWatcher(): SagaIterator {
  yield takeEvery(COGNITO_RETRY_FLOW, createCognitoRetryWorker);
}
mergeSaga(createCognitoRetryWatcher);

function* createCognitoRetryWorker(): SagaIterator {
  try {
    const result = yield call(getApiPlayer);

    if (result.data && result.data.url) {
      window.open(result.data.url);
    }

    yield put(createCognitoRetrySuccessAction(result.data));
    yield put(getUserInfoAction());
  } catch (e: any) {
    if (e.response && e.response.data && e.response.data.statusCode && e.response.data.statusCode == -3) {
      yield put(
        toggleVerifyIdentityDialogAction({
          open: true,
          message: e.response.data.messages[0].msg,
          result: false,
          playerProfileSettingsPaymentMethodBonuses: [],
        }),
      );
    }
    yield put(createCognitoRetryErrorAction(e.response?.data?.error || ''));
  }
}

export const getApiPlayer = (): Request => {
  return vipApi(API_PATH.USER.COGNITO_CREATE_RETRY_FLOW_SESSION, 'post', {});
};

export const getCognitoUrl = async (): Promise<any> => {
  return await vipApi(API_PATH.USER.COGNITO_CREATE_RETRY_FLOW_SESSION, 'post', {});
};

const reduceHandlers = {
  [COGNITO_RETRY_FLOW]: (slice: UserSliceType): UserSliceType => ({
    ...slice,
    isLoading: true,
    shareable_url: null,
    window_opened: null,
  }),
  [COGNITO_RETRY_FLOW_SUCCESS]: (slice: UserSliceType, action: Action<ICognitoReTryFlowSession>): UserSliceType => {
    return {
      ...slice,
      isLoading: false,
      shareable_url: action.payload.url,
      window_opened: action.payload.new_window ?? null,
    };
  },
  [COGNITO_RETRY_FLOW_ERROR]: (slice: UserSliceType): UserSliceType => ({
    ...slice,
    isLoading: false,
    shareable_url: null,
    window_opened: null,
  }),
  [CLEAR_COGNITO_URL]: (slice: UserSliceType): UserSliceType => ({
    ...slice,
    shareable_url: null,
  }),
};
userReducer.addActionReducerMap(reduceHandlers);
